import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Navbar from './Navbar';
import API_BASE_URL from '../api';

const SexInfo = () => {
  const [sexInfo, setSexInfo] = useState({
    sex: '',
    otherSex: '', // To store the value of "Other" sex if selected
    orientation: '',
    otherOrientation: '', // To store the value of "Other" orientation if selected
    identification: '',
    pronouns: '',
  });

  const [message, setMessage] = useState('');
  const [isNewUser, setIsNewUser] = useState(false);

  const getAuthToken = () => localStorage.getItem('stack_access_token');
  const navigate = useNavigate();

  const predefinedSexOptions = ['Male', 'Female'];
  const predefinedOrientationOptions = [
    'Straight',
    'Gay',
    'Lesbian',
    'Bisexual',
    'Demisexual',
    'Pansexual',
    'Queer',
    'Questioning',
  ];

  useEffect(() => {
    const token = getAuthToken();
    fetch(`${API_BASE_URL}/api/sex-info`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'X-Stack-Access-Token': token,
      },
    })
      .then((response) => {
        if (response.status === 404) {
          setIsNewUser(true);
          setMessage('No sex info found. Please set your sex info.');
          return;
        }
        if (!response.ok) {
          throw new Error('Failed to fetch sex info');
        }
        return response.json();
      })
      .then((data) => {
        if (data) {
          const sexData = data.reduce((acc, item) => {
            if (item.question_text === 'What is your sex?') {
              acc.sex = predefinedSexOptions.includes(item.answer_text)
                ? item.answer_text
                : 'Other';
              acc.otherSex = predefinedSexOptions.includes(item.answer_text)
                ? ''
                : item.answer_text;
            }
            if (item.question_text === 'What is your orientation?') {
              acc.orientation = predefinedOrientationOptions.includes(
                item.answer_text,
              )
                ? item.answer_text
                : 'Other';
              acc.otherOrientation = predefinedOrientationOptions.includes(
                item.answer_text,
              )
                ? ''
                : item.answer_text;
            }
            if (item.question_text === 'How do you identify?')
              acc.identification = item.answer_text;
            if (item.question_text === 'What are your pronouns?')
              acc.pronouns = item.answer_text;
            return acc;
          }, {});
          setSexInfo(sexData);
        }
      })
      .catch((error) => {
        console.error('Error fetching sex info:', error);
        setMessage('Error fetching sex info.');
      });
  });

  const handleSubmit = async (e) => {
    e.preventDefault();

    const token = getAuthToken();

    const payload = {
      ...sexInfo,
      sex: sexInfo.sex === 'Other' ? sexInfo.otherSex : sexInfo.sex,
      orientation:
        sexInfo.orientation === 'Other'
          ? sexInfo.otherOrientation
          : sexInfo.orientation,
    };

    const method = isNewUser ? 'POST' : 'PUT';

    try {
      const response = await fetch(`${API_BASE_URL}/api/sex-info`, {
        method: method,
        headers: {
          'X-Stack-Access-Token': token,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        throw new Error('Failed to update sex info');
      }

      setSexInfo(payload); // Update state
      setMessage('Sex info updated successfully.');

      setTimeout(() => {
        navigate('/seeking-info');
      }, 2000);

      setIsNewUser(false);
    } catch (error) {
      console.error('Error setting sex info:', error);
      setMessage('Failed to update sex info.');
    }
  };

  const handleChange = (e) => {
    setSexInfo({
      ...sexInfo,
      [e.target.name]: e.target.value,
    });
  };

  return (
    <div
      className="min-h-screen flex flex-col"
      style={{ backgroundColor: '#0D2329' }}
    >
      <Navbar />
      <div className="flex-1 flex justify-center items-center">
        <div
          className="w-full max-w-md p-8 rounded-lg shadow-md"
          style={{ backgroundColor: '#05664f' }}
        >
          <h1 className="text-4xl font-bold text-white text-center mb-6">
            Sex Info
          </h1>
          {message && (
            <p className="text-sm text-red-200 text-center mb-4">{message}</p>
          )}
          <form onSubmit={handleSubmit} className="space-y-4">
            <div className="text-white">
              <label className="block text-sm font-medium">
                What is your sex?
                <select
                  name="sex"
                  value={sexInfo.sex || ''}
                  onChange={handleChange}
                  className="mt-1 block w-full px-3 py-2 text-base border border-gray-300 text-black sm:text-sm rounded-md"
                  required
                >
                  <option value="">Select your sex</option>
                  <option value="Male">Male</option>
                  <option value="Female">Female</option>
                  <option value="Other">Other</option>
                </select>
              </label>
              {sexInfo.sex === 'Other' && (
                <div className="mt-2">
                  <label className="block text-sm font-medium">
                    Please specify your sex:
                    <input
                      type="text"
                      name="otherSex"
                      value={sexInfo.otherSex || ''}
                      onChange={handleChange}
                      className="mt-1 block w-full px-3 py-2 text-base border border-gray-300 text-black sm:text-sm rounded-md"
                      required
                    />
                  </label>
                </div>
              )}
            </div>
            <div className="text-white">
              <label className="block text-sm font-medium">
                What is your orientation?
                <select
                  name="orientation"
                  value={sexInfo.orientation || ''}
                  onChange={handleChange}
                  className="mt-1 block w-full px-3 py-2 text-base border border-gray-300 text-black sm:text-sm rounded-md"
                  required
                >
                  <option value="">Select your orientation</option>
                  <option value="Straight">Straight</option>
                  <option value="Gay">Gay</option>
                  <option value="Lesbian">Lesbian</option>
                  <option value="Bisexual">Bisexual</option>
                  <option value="Demisexual">Demisexual</option>
                  <option value="Pansexual">Pansexual</option>
                  <option value="Queer">Queer</option>
                  <option value="Questioning">Questioning</option>
                  <option value="Other">Other</option>
                </select>
              </label>
              {sexInfo.orientation === 'Other' && (
                <div className="mt-2">
                  <label className="block text-sm font-medium">
                    Please specify your orientation:
                    <input
                      type="text"
                      name="otherOrientation"
                      value={sexInfo.otherOrientation || ''}
                      onChange={handleChange}
                      className="mt-1 block w-full px-3 py-2 text-base border border-gray-300 text-black sm:text-sm rounded-md"
                      required
                    />
                  </label>
                </div>
              )}
            </div>
            <div className="text-white">
              <label className="block text-sm font-medium">
                How do you identify?
                <input
                  type="text"
                  name="identification"
                  value={sexInfo.identification || ''}
                  onChange={handleChange}
                  className="mt-1 block w-full px-3 py-2 text-base border border-gray-300 text-black sm:text-sm rounded-md"
                  required
                />
              </label>
            </div>
            <div className="text-white">
              <label className="block text-sm font-medium">
                What are your pronouns?
                <input
                  type="text"
                  name="pronouns"
                  value={sexInfo.pronouns || ''}
                  onChange={handleChange}
                  className="mt-1 block w-full px-3 py-2 text-base border border-gray-300 text-black sm:text-sm rounded-md"
                  required
                />
              </label>
            </div>
            <button
              type="submit"
              className="w-full px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-black focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
            >
              Next
            </button>

            <button
              type="button"
              className="w-full px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 mt-2"
              onClick={() => navigate('/location-info')} // Navigate back to the previous form
            >
              Previous
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default SexInfo;
